'use client';

import {
  ROAD_EXAM_COMMON_LIST,
  ROAD_EXAM_SUMMARY,
} from '@/data/exam/exam.data';
import ExamGuideList from '../components/exam-guide-list';
import ExamGuideSummary from '../components/exam-guide-summary';

export default function Client() {
  return (
    <>
      <ExamGuideSummary items={ROAD_EXAM_SUMMARY} />
      <ExamGuideList items={ROAD_EXAM_COMMON_LIST} />
    </>
  );
}
